/* eslint-disable jira/filename-case */
import { createContext, type Context } from 'react';

export const detectionBoundary: Context<boolean> = createContext(true);
